var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"internal"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("Page not found!")]),_vm._v(" "),_c('p',[_vm._v("The page you are looking for could not be found!")]),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Click here")]),_vm._v(" to return to our homepage.")],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65d40506","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/errors/NotFound.vue
// module id = null
// module chunks = 